import React from 'react';
import { content } from '../../content';
import { BlogPost } from '../../types';
import { formatPostDate, readingTime } from '../../utils/blog';
import { ArrowRightIcon } from '../Icon';
import '../../styles/Blog.css';

const { ui } = content;

/**
 * One entry in the feed. The whole card is the link — a reader aiming at a
 * headline on a phone should not have to hit a small "читать" instead.
 */
const BlogCard = ({ post, onOpen }: { post: BlogPost; onOpen: () => void }) => {
  const date = formatPostDate(post.date);

  return (
    <li className={`feed-card${post.cover ? '' : ' feed-card--bare'}`}>
      <button
        type="button"
        className="feed-card__hit"
        aria-label={ui.blogOpen(post.title)}
        onClick={onOpen}
      />

      {post.cover && (
        <div className="feed-card__cover">
          {/* Decorative here: the headline right next to it says the same
              thing, and the cover's own alt is read inside the article. */}
          <img src={post.cover.src} alt="" loading="lazy" decoding="async" />
        </div>
      )}

      <div className="feed-card__body">
        <div className="feed-card__meta">
          {date && (
            <time dateTime={post.date}>{date}</time>
          )}
          <span className="post__dot" aria-hidden>
            ·
          </span>
          <span>{readingTime(post)}</span>
        </div>

        <h2 className="feed-card__title">{post.title}</h2>
        <p className="feed-card__excerpt">{post.excerpt}</p>

        <div className="feed-card__foot">
          <ul className="feed-card__tags">
            {post.tags.map((tag) => (
              <li key={tag} className="chip chip--sm">
                {tag}
              </li>
            ))}
          </ul>
          <span className="feed-card__read">
            {ui.blogRead}
            <ArrowRightIcon size={14} />
          </span>
        </div>
      </div>
    </li>
  );
};

export default BlogCard;
